export const API_URL = process.env.VITE_API_URL || ""

export const AUTH0_DOMAIN = process.env.VITE_AUTH0_DOMAIN || ""
export const AUTH0_CLIENTID = process.env.VITE_AUTH0_CLIENTID || ""
export const AUTH0_AUDIENCE = process.env.VITE_AUTH0_AUDIENCE || ""

export const LEVEL = process.env.VITE_LEVEL || "local"
export const IS_PROD = LEVEL === "prod"
export const IS_DEV = LEVEL === "stage"

export const LAUNCH_DARKLY_CLIENT_ID = process.env.VITE_LAUNCH_DARKLY_CLIENT_ID || ""
export const MUI_LICENSE_KEY = process.env.VITE_MUI_LICENSE || ""

export const PLAYWRIGHT_USERNAME = process.env.VITE_PLAYWRIGHT_USERNAME || ""
export const PLAYWRIGHT_PASSWORD = process.env.VITE_PLAYWRIGHT_PASSWORD || ""
